import PageMigrationVerify from '@/pages/PageMigrationVerify'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		...opts,
		vueComponent: PageMigrationVerify
	}

	let page = vuewidget(dom, options)
	return page
}